__turbopack_context__.v({
  "bio": "G4rkvW_bio",
  "brandsGrid": "G4rkvW_brandsGrid",
  "footer": "G4rkvW_footer",
  "fullName": "G4rkvW_fullName",
});
